import React, { useState } from 'react'
import { useNavigate } from 'react-router';
import { formatDate } from '../../helper/formatDate';
import { useTranslate } from '../TranslationText';
import CustomPopUp from '../CustomPopUp';
import EahsForm from '../EahsForm';
import { addedithorsequalification, deleteShowEntry, getCountries, gethorsequalificationbyhorseid } from '../../pages/showEntry/apis/CreateShowEntry';
import { isValidUrl } from '../../helper/validateURL';
import { eformInput } from '../../common/cssclasses';
import NetaqInput from '../NetaqInput';
import { isEmpty } from '../../helper/validaiteInputs';
import UploadFile from '../SimpleFileUpload';
import { AddEditAuctionHorse, DeleteAuctionHorse, GetAuctionHorseRequestById } from '../../pages/AuctionEntry/apis/AuctionEntryApis';
import { formatDateTimeToString } from '../../helper/formatDateTimeToString';

const BaseURL = process.env.REACT_APP_BASE_URL;
export default function AuctionEntryHorseCard({ horse, onClick, updateHorseInArray, getHorseList, isSelectedTab = false, auctionId, showDetails = {}, toast }) {
    const navigate = useNavigate();
    const { translate } = useTranslate();
    const [countriesData, setCountriesData] = useState([]);
    const [isSending, setIsSending] = useState(false);
    const handleDetailsChange = (e) => {
        setHorseDetailsObj({
            ...horseDetailsObj,
            [e.target.name]: e.target.value
        })
    };

    const detailsObj = {
        auctionHorseId: "",
        auctionId: "",
        horseId: "",
        ownerId: localStorage.getItem("currentSubAccountId"),
        createdBy: localStorage.getItem("EAHSUserID"),
        horsePerformanceEn: "",
        horsePerformanceAr: "",
        horseStartingPrice: "",
        minimumPreferredPrice: "",
        horseIncrementalIncrease: "",
        horseVideo: "",
        auctionHorseFiles: "",
        isSemen: false,
    }
    const [horseDetailsObj, setHorseDetailsObj] = useState(detailsObj)


    function submitHorseDetails() {
        const theField = `${translate('web.theField', 'The Field')} `;
        const isrequired = ` ${translate('web.isRequired', 'Is Required')}`;

        if (isEmpty(horseDetailsObj.horsePerformanceEn)) {
            toast.error(theField + translate('web.horsePerformanceEn', 'horsePerformanceEn') + isrequired);
            return false;
        }
        if (isEmpty(horseDetailsObj.horsePerformanceAr)) {
            toast.error(theField + translate('web.horsePerformanceAr', 'horsePerformanceAr') + isrequired);
            return false;
        }
        if (isEmpty(horseDetailsObj?.horseStartingPrice?.toString() ?? '')) {
            toast.error(theField + translate('web.horseStartingPrice', 'horseStartingPrice') + isrequired);
            return false;
        }
        if (isEmpty(horseDetailsObj?.minimumPreferredPrice?.toString() ?? '')) {
            toast.error(theField + translate('web.minimumPreferredPrice', 'minimumPreferredPrice') + isrequired);
            return false;
        }
        if (isEmpty(horseDetailsObj?.horseIncrementalIncrease?.toString() ?? '')) {
            toast.error(theField + translate('web.horseIncrementalIncrease', 'horseIncrementalIncrease') + isrequired);
            return false;
        }
        if (!!horseDetailsObj?.horseVideo ?? false) {
            if (!isValidUrl(horseDetailsObj?.horseVideo)) {
                toast.error(theField + translate('web.urlNotValid', 'websiteURL'));
                return false;
            }
        }
        if (coverImage?.length <= 0) {
            toast.error(theField + translate('web.coverImage', 'coverImage') + isrequired);
            return false;
        }
        if (featureImage?.length <= 0) {
            toast.error(theField + translate('web.featureImage', 'featureImage') + isrequired);
            return false;
        }


        setIsSending(true);
        const obj = {
            horseId: horse?.id,
            auctionId: auctionId,
            ownerId: localStorage.getItem('currentSubAccountId'),
            horsePerformanceEn: horseDetailsObj.horsePerformanceEn,
            horsePerformanceAr: horseDetailsObj.horsePerformanceAr,
            horseStartingPrice: horseDetailsObj.horseStartingPrice,
            minimumPreferredPrice: horseDetailsObj.minimumPreferredPrice,
            horseIncrementalIncrease: horseDetailsObj.horseIncrementalIncrease,
            horseVideo: horseDetailsObj.horseVideo ?? '',
            createdBy: localStorage.getItem('EAHSUserID'),
            isSemen: horseDetailsObj.isSemen
        }
        let formData = new FormData();
        for (const key in obj) {
            if (Object.prototype.hasOwnProperty.call(obj, key)) {
                formData.append(key, obj[key]);
            }
        }
        if (!featureImage[0]?.documentUrl) {
            formData.append('auctionHorseFiles[0].documentType', 'HorseFeatureImage');
            formData.append('auctionHorseFiles[0].documentFile', featureImage[0]?.file);
        }
        if (!coverImage[0]?.documentUrl) {
            formData.append('auctionHorseFiles[1].documentType', 'HorseCoverImage');
            formData.append('auctionHorseFiles[1].documentFile', coverImage[0]?.file);
        }
        if (additionalImage.length > 0) {
            if (!additionalImage[0]?.documentUrl) {
                formData.append('auctionHorseFiles[2].documentType', 'AuctionHorse');
                formData.append('auctionHorseFiles[2].documentFile', additionalImage[0]?.file);
            }
        }
        if (isSelectedTab) {
            formData.append('id', horse?.auctionHorseId);
        }
        AddEditAuctionHorse(formData).then((res) => {
            if (!!res?.auctionHorseId) {
                updateHorseInArray(horse?.id, res?.auctionHorseId)
                setTimeout(() => {
                    toast.success(translate('web.horseAddedSuccessfully', 'Horse Added Successfully'))
                }, 500);
            }
            if (res?.responseCode == '201') {
                const auctionHorseId = res?.result?.auctionHorseId;
                updateHorseInArray(horse?.id, auctionHorseId, false, true);
                setTimeout(() => {
                    toast.warning(translate('web.horseAddedToWatitngList', 'Horse Added To Watitng List'))
                }, 500);
            }
            if (res?.responseCode == '100') {
                setTimeout(() => {
                    toast.error(res?.responseText);
                }, 500);
            }
            setIsSending(false);
        })

    }

    function deleteHorse() {
        if (horse?.auctionHorseId) {
            DeleteAuctionHorse(horse?.auctionHorseId).then((res) => {
                if (res) {
                    toast.success(translate('web.horseDeletedSuccessfully', 'Horse Deleted Successfully'))
                    const ownerId = localStorage.getItem('currentSubAccountId');
                    getHorseList(ownerId);
                    onClick();
                } else {
                    toast.error(translate('web.horseDeletedFaild', 'Horse Deleted Faild'))
                }
            })

        } else {
            onClick()
        }
    }


    function onOpenPopUp() {
        GetAuctionHorseRequestById(horse?.auctionHorseId).then((res) => {
            ;
            const detailsObj = {
                auctionHorseId: res?.auctionHorseId,
                auctionId: auctionId,
                horseId: res?.horseId,
                ownerId: res?.ownerId,
                createdBy: localStorage.getItem("EAHSUserID"),
                horsePerformanceEn: res?.horsePerformanceEn,
                horsePerformanceAr: res?.horsePerformanceAr,
                horseStartingPrice: res?.horseStartingPrice,
                minimumPreferredPrice: res?.minimumPreferredPrice,
                horseIncrementalIncrease: res?.horseIncrementalIncrease,
                horseVideo: res?.horseVideo,
                isSemen: res?.isSemen,
            }
            setHorseDetailsObj(detailsObj);
            if (res?.coverImage != null) {
                setCoverImage([{
                    documentUrl: res?.coverImage?.fileUrl,
                    file: res?.coverImage?.fileUrl,
                    name: res?.coverImage?.name,
                }])
            }
            if (res?.featureImage != null) {
                setFeatureImage([{
                    documentUrl: res?.featureImage?.fileUrl,
                    file: res?.featureImage?.fileUrl,
                    name: res?.featureImage?.name,
                }])

            }
            if (res?.additionalImage != null && res?.additionalImage?.length > 0) {
                setAdditionalImage([{
                    documentUrl: res?.additionalImage[0]?.fileUrl,
                    file: res?.additionalImage[0]?.fileUrl,
                    name: res?.additionalImage[0]?.name,
                }])
            }



            console.log('res GetAuctionHorseRequestById', res);
        })
    }

    const [coverImage, setCoverImage] = useState([]);
    const [featureImage, setFeatureImage] = useState([]);
    const [additionalImage, setAdditionalImage] = useState([]);

    const uploadCoverImage = (e) => {
        if (e.target.files && e.target.files.length > 0) {
            if (e.target.files[0].size > 10 * 1024 * 1024) {
                toast.error(translate("web.fileSizeLimit", "File size 10MB limit."));
            } else {
                setCoverImage([
                    {
                        file: e.target.files[0],
                        name: e.target.files[0].name,
                    },
                ]);
            }
        }
    };
    const uploadFeatureImage = (e) => {
        if (e.target.files && e.target.files.length > 0) {
            if (e.target.files[0].size > 10 * 1024 * 1024) {
                toast.error(translate("web.fileSizeLimit", "File size 10MB limit."));
            } else {
                setFeatureImage([
                    {
                        file: e.target.files[0],
                        name: e.target.files[0].name,
                    },
                ]);
            }
        }
    };
    const uploadAdditionalImage = (e) => {

        if (e.target.files && e.target.files.length > 0) {
            if (e.target.files[0].size > 10 * 1024 * 1024) {
                toast.error(translate("web.fileSizeLimit", "File size 10MB limit."));
            } else {
                setAdditionalImage([
                    {
                        file: e.target.files[0],
                        name: e.target.files[0].name,
                    },
                ]);
            }
        }
    };

    return (
        <div className={'hourseCardClass bg-white p-main border-15 p-3 mb-main'} style={{ minHeight: "unset" }}>
            <div className='w-100 fw-bold' >
                <i className=" fa-solid fa-chess-knight C89C66" />{horse?.regNr} - {horse?.name}
            </div>
            <div className='w-100' ><i className=" fa fa-calendar C89C66" />{formatDateTimeToString(horse?.birthDateObject)}</div>
            {!!horse?.ownerName &&
                <div className='w-100' ><i className=" fa fa-user C89C66" />{horse?.ownerName}</div>
            }
            <div className='w-100' ><i className=" fa fa-globe-americas C89C66" />{horse?.origin}</div>
            {horse?.categoryName &&
                <div className='w-100' ><i className=" fa fa-tags C89C66" />{horse?.categoryName}</div>
            }
            {horse?.isSelected == false && (horse?.status == "" || horse?.status?.toLowerCase() == 'draft') &&
                <CustomPopUp
                    trigger={
                        <div className='position-absolute top-0 end-0 mt-3 me-3' title={translate('web.horseDetails', 'Horse Details')} style={{ cursor: 'pointer' }} ><i className=" fa C89C66 fa-plus"></i></div>
                    }
                    title={translate("web.horseDetails", "Horse Details") + " " + `${horse?.regNr} - ${horse?.name}`}
                    content={
                        <EahsForm className='mb-main' >
                            {horse?.gender == 'Stallion' &&
                                <div className='col-12 mb-form-group'>
                                    <NetaqInput
                                        name={"isSemen"}
                                        type={"checkbox"}
                                        label={translate(
                                            "web.isSemen",
                                            "isSemen"
                                        )}
                                        onChange={(e) => {
                                            setHorseDetailsObj((prev) => ({ ...prev, isSemen: e.target.checked }))
                                        }
                                        }
                                    />
                                </div>
                            }
                            <div className={eformInput}>
                                <NetaqInput
                                    label={translate(
                                        "web.horsePerformanceEn",
                                        "Horse Performance (En)"
                                    )}
                                    name={"horsePerformanceEn"}
                                    placeholder={translate(
                                        "web.horsePerformanceEn",
                                        "Horse Performance (En)"
                                    )}
                                    type={"textarea"}
                                    onChange={handleDetailsChange}
                                    value={horseDetailsObj?.horsePerformanceEn}
                                    required={true}
                                />
                            </div>
                            <div className={eformInput}>
                                <NetaqInput
                                    label={translate(
                                        "web.horsePerformanceAr",
                                        "Horse Performance (Ar)"
                                    )}
                                    name={"horsePerformanceAr"}
                                    placeholder={translate(
                                        "web.horsePerformanceAr",
                                        "Horse Performance (Ar)"
                                    )}
                                    type={"textarea"}
                                    maxchars={1000}
                                    onChange={handleDetailsChange}
                                    value={horseDetailsObj.horsePerformanceAr}
                                    required={true}
                                />
                            </div>
                            <div className={eformInput}>
                                <NetaqInput
                                    label={translate(
                                        "web.horseStartingPrice",
                                        "Horse Starting Price"
                                    )}
                                    name={"horseStartingPrice"}
                                    placeholder={translate(
                                        "web.horseStartingPrice",
                                        "Horse Starting Price"
                                    )}
                                    type={"number"}
                                    required={true}
                                    onChange={handleDetailsChange}
                                    value={horseDetailsObj.horseStartingPrice}
                                />

                            </div>
                            <div className={eformInput}>
                                <NetaqInput
                                    label={translate(
                                        "web.minimumPreferredPrice",
                                        "Minimum Preferred Price"
                                    )}
                                    name={"minimumPreferredPrice"}
                                    placeholder={translate(
                                        "web.minimumPreferredPrice",
                                        "Minimum Preferred Price"
                                    )}
                                    type={"number"}
                                    required={true}
                                    onChange={handleDetailsChange}
                                    value={horseDetailsObj.minimumPreferredPrice}
                                />
                            </div>
                            <div className={eformInput}>
                                <NetaqInput
                                    label={translate(
                                        "web.horseIncrementalIncrease",
                                        "Horse Incremental Increase"
                                    )}
                                    name={"horseIncrementalIncrease"}
                                    placeholder={translate(
                                        "web.horseIncrementalIncrease",
                                        "Horse Incremental Increase"
                                    )}
                                    type={"number"}
                                    required={true}
                                    onChange={handleDetailsChange}
                                    value={horseDetailsObj.horseIncrementalIncrease}
                                />
                            </div>
                            <div className={eformInput}>
                                <NetaqInput
                                    label={translate("web.horseVideo", "Horse Video Url")}
                                    name={"horseVideo"}
                                    placeholder={translate(
                                        "web.horseVideo",
                                        "Horse Video Url"
                                    )}
                                    type={"text"}
                                    onChange={handleDetailsChange}
                                    value={horseDetailsObj.horseVideo}
                                />
                                {!!horseDetailsObj.horseVideo && (!isValidUrl(horseDetailsObj.horseVideo)) &&
                                    <span className={`text-danger`}>
                                        {translate("web.urlNotValid", "URL not valid")}
                                    </span>
                                }
                            </div>
                            <div className={eformInput}>
                                <label class="capatalize_text">
                                    {translate("web.coverImage", "Cover Image")}
                                    <i className='mx-2' style={{ color: "red" }}>*</i>
                                    {translate('web.imageRatio870X350', 'W870XH350')}

                                </label>
                                <UploadFile
                                    text={"Upload"}
                                    initialFiles={
                                        coverImage
                                    }
                                    isServer={coverImage.length > 0 &&
                                        !!coverImage[0]?.documentUrl
                                    }
                                    onChange={uploadCoverImage}
                                    iconClassName={"fa-solid fa-upload fa-lg marginrightleft-5"}
                                    accept={"image/*"}

                                />
                            </div>
                            <div className={eformInput}>
                                <label class="capatalize_text">
                                    {translate("web.featureImage", "Feature Image")}
                                    <i className='mx-2' style={{ color: "red" }}>*</i>
                                    {translate('web.imageRatio870X350', 'W870XH350')}

                                </label>
                                <UploadFile
                                    text={"Upload"}
                                    initialFiles={
                                        featureImage
                                    }
                                    isServer={featureImage.length > 0 &&
                                        !!featureImage[0]?.documentUrl
                                    }
                                    onChange={uploadFeatureImage}
                                    iconClassName={"fa-solid fa-upload fa-lg marginrightleft-5"}
                                    accept={"image/*"}
                                />
                            </div>
                            <div className={eformInput}>
                                <label class="capatalize_text">
                                    {translate("web.additionalImage", "Additional Image")}
                                    {" - " + translate('web.imageRatio400X160', 'W400XH160')}
                                </label>
                                <UploadFile
                                    text={"Upload"}
                                    initialFiles={
                                        additionalImage
                                    }
                                    isServer={additionalImage.length > 0 &&
                                        !!additionalImage[0]?.documentUrl
                                    }
                                    onChange={uploadAdditionalImage}
                                    iconClassName={"fa-solid fa-upload fa-lg marginrightleft-5"}
                                    accept={"image/*"}
                                />
                            </div>


                        </EahsForm>
                    }
                    onClick={submitHorseDetails}
                />
            }
            {horse?.isSelected == true && isSelectedTab && (horse?.status == "" || horse?.status?.toLowerCase() == 'draft' || horse?.status?.toLowerCase() == 'pendingpayment') &&
                <CustomPopUp
                    trigger={
                        <div className='position-absolute bottom-0 end-0 mb-3 me-3' title={translate('web.horseDetails', 'Horse Details')} style={{ cursor: 'pointer' }} ><i className=" fa C89C66 fa-edit"></i></div>
                    }
                    title={translate("web.horseDetails", "Horse Details") + " " + `${horse?.regNr} - ${horse?.name}`}
                    onOpen={() => {
                        onOpenPopUp()
                    }}
                    content={
                        <EahsForm className='mb-main' >
                            {horse?.gender == 'Stallion' &&
                                <div className='col-12 mb-form-group'>
                                    <NetaqInput
                                        name={"isSemen"}
                                        type={"checkbox"}
                                        label={translate(
                                            "web.isSemen",
                                            "isSemen"
                                        )}
                                        onChange={(e) => {
                                            setHorseDetailsObj((prev) => ({ ...prev, isSemen: e.target.checked }))
                                        }}
                                        checked={horseDetailsObj.isSemen}
                                    />
                                </div>
                            }
                            <div className={eformInput}>
                                <NetaqInput
                                    label={translate(
                                        "web.horsePerformanceEn",
                                        "Horse Performance (En)"
                                    )}
                                    name={"horsePerformanceEn"}
                                    placeholder={translate(
                                        "web.horsePerformanceEn",
                                        "Horse Performance (En)"
                                    )}
                                    type={"textarea"}
                                    onChange={handleDetailsChange}
                                    value={horseDetailsObj?.horsePerformanceEn}
                                    required={true}
                                />
                            </div>
                            <div className={eformInput}>
                                <NetaqInput
                                    label={translate(
                                        "web.horsePerformanceAr",
                                        "Horse Performance (Ar)"
                                    )}
                                    name={"horsePerformanceAr"}
                                    placeholder={translate(
                                        "web.horsePerformanceAr",
                                        "Horse Performance (Ar)"
                                    )}
                                    type={"textarea"}
                                    maxchars={1000}
                                    onChange={handleDetailsChange}
                                    value={horseDetailsObj.horsePerformanceAr}
                                    required={true}
                                />
                            </div>
                            <div className={eformInput}>
                                <NetaqInput
                                    label={translate(
                                        "web.horseStartingPrice",
                                        "Horse Starting Price"
                                    )}
                                    name={"horseStartingPrice"}
                                    placeholder={translate(
                                        "web.horseStartingPrice",
                                        "Horse Starting Price"
                                    )}
                                    type={"number"}
                                    required={true}
                                    onChange={handleDetailsChange}
                                    value={horseDetailsObj.horseStartingPrice}
                                />

                            </div>
                            <div className={eformInput}>
                                <NetaqInput
                                    label={translate(
                                        "web.minimumPreferredPrice",
                                        "Minimum Preferred Price"
                                    )}
                                    name={"minimumPreferredPrice"}
                                    placeholder={translate(
                                        "web.minimumPreferredPrice",
                                        "Minimum Preferred Price"
                                    )}
                                    type={"number"}
                                    required={true}
                                    onChange={handleDetailsChange}
                                    value={horseDetailsObj.minimumPreferredPrice}
                                />
                            </div>
                            <div className={eformInput}>
                                <NetaqInput
                                    label={translate(
                                        "web.horseIncrementalIncrease",
                                        "Horse Incremental Increase"
                                    )}
                                    name={"horseIncrementalIncrease"}
                                    placeholder={translate(
                                        "web.horseIncrementalIncrease",
                                        "Horse Incremental Increase"
                                    )}
                                    type={"number"}
                                    required={true}
                                    onChange={handleDetailsChange}
                                    value={horseDetailsObj.horseIncrementalIncrease}
                                />
                            </div>
                            <div className={eformInput}>
                                <NetaqInput
                                    label={translate("web.horseVideo", "Horse Video Url")}
                                    name={"horseVideo"}
                                    placeholder={translate(
                                        "web.horseVideo",
                                        "Horse Video Url"
                                    )}
                                    type={"text"}
                                    onChange={handleDetailsChange}
                                    value={horseDetailsObj.horseVideo}
                                //required={true}
                                />
                                {horseDetailsObj?.horseVideo && (!isValidUrl(horseDetailsObj.horseVideo)) &&
                                    <span className={`text-danger`}>
                                        {translate("web.urlNotValid", "URL not valid")}
                                    </span>
                                }
                            </div>
                            <div className={eformInput}>
                                <label class="capatalize_text">
                                    {translate("web.coverImage", "Cover Image")}
                                    <i style={{ color: "red" }}>*</i>
                                </label>
                                <UploadFile
                                    text={"Upload"}
                                    initialFiles={
                                        coverImage
                                    }
                                    isServer={coverImage.length > 0 &&
                                        !!coverImage[0]?.documentUrl
                                    }
                                    onChange={uploadCoverImage}
                                    iconClassName={"fa-solid fa-upload fa-lg marginrightleft-5"}
                                    accept={"image/*"}

                                />
                            </div>
                            <div className={eformInput}>
                                <label class="capatalize_text">
                                    {translate("web.featureImage", "Feature Image")}
                                    <i style={{ color: "red" }}>*</i>
                                </label>
                                <UploadFile
                                    text={"Upload"}
                                    initialFiles={
                                        featureImage
                                    }
                                    isServer={featureImage.length > 0 &&
                                        !!featureImage[0]?.documentUrl
                                    }
                                    onChange={uploadFeatureImage}
                                    iconClassName={"fa-solid fa-upload fa-lg marginrightleft-5"}
                                    accept={"image/*"}
                                />
                            </div>
                            <div className={eformInput}>
                                <label class="capatalize_text">
                                    {translate("web.additionalImage", "Additional Image")}
                                </label>
                                <UploadFile
                                    text={"Upload"}
                                    initialFiles={
                                        additionalImage
                                    }
                                    isServer={additionalImage.length > 0 &&
                                        !!additionalImage[0]?.documentUrl
                                    }
                                    onChange={uploadAdditionalImage}
                                    iconClassName={"fa-solid fa-upload fa-lg marginrightleft-5"}
                                    accept={"image/*"}
                                />
                            </div>


                        </EahsForm>
                    }
                    onClick={submitHorseDetails}
                />
            }
            {isSelectedTab && (horse?.status == "" || horse?.status?.toLowerCase() == 'draft' || horse?.status?.toLowerCase() == 'pendingpayment') &&
                <div className='position-absolute top-0 end-0 mt-3 me-3' style={{ cursor: 'pointer' }} onClick={() => { deleteHorse() }} >
                    <i className="fa C89C66 fa-trash"></i>
                </div>
            }
        </div>
    )
}
